import { CancelTokenSource } from 'axios'
import Agent from '../api/Agent'
import { BookmarksDeleteRequest, BookmarksRequest } from '../models/Bookmarks'
import { IBookmarksType, IPaginationFilter } from '../models/Common'

class BookmarksService {
  getBookmarks(
    filter: IPaginationFilter,
    bookmarksType: IBookmarksType,
    source?: CancelTokenSource
  ) {
    return Agent.Bookmarks.getBookmarks(filter, bookmarksType, source)
  }

  removeBookmark = async (request: BookmarksDeleteRequest) => {
    return Agent.Bookmarks.removeBookmark(request)
  }
  createBookmark = async (request: BookmarksRequest) => {
    return Agent.Bookmarks.createBookmark(request)
  }
}

export default new BookmarksService()
